import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Collapse SVG Icon for collapse button.
 */
export const Collapse: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG
    width="100%"
    height="100%"
    viewBox="0 0 17 17"
    aria-hidden={true}
    {...props}
  >
    <path
      d="M17 1.1985L12.5035 5.695L15.3 8.5H8.5V1.7L11.2965 4.4965L15.8015 0L17 1.1985ZM1.1985 17L5.695 12.5035L8.5 15.3V8.5H1.7L4.4965 11.2965L0 15.8015L1.1985 17Z"
      fill={props.fill ?? 'currentColor'}
    />
  </AccessibleSVG>
)
